/**
 * Position-derived — a letter carried in the option text drifts from the explanations citing it
 * when options are reordered.
 */
export const letterFor = (index: number): string => String.fromCharCode(65 + index);
